/** Alanın hata bağlantısı (`components/feedback/FieldError`): `aria-invalid` + `aria-describedby`. */
export function fieldErrorProps(id: string, message?: string | null) {
  return {
    'aria-invalid': !!message,
    'aria-describedby': message ? `${id}-error` : undefined,
  }
}
